import React from 'react';

import classNames from 'classnames';
import BadgeNominee from './assets/nominee.svg';
import BadgeRunnerUp from './assets/runnerup.svg';
import BadgeWinner from './assets/winner.svg';
import styles from './DesignAwardBadge.module.scss';

export enum DesignAwardPlace {
  'WINNER' = 'WINNER',
  'RUNNER_UP' = 'RUNNER_UP',
  'NOMINEE' = 'NOMINEE'
}

interface IDesignAward {
  place: DesignAwardPlace;
  className?: string;
}

export default function DesignAwardBadge({
  place,
  className
}: IDesignAward) {
  let Badge;
  switch (place) {
    case DesignAwardPlace.NOMINEE: {
      Badge = BadgeNominee;
      break;
    }
    case DesignAwardPlace.RUNNER_UP: {
      Badge = BadgeRunnerUp;
      break;
    }
    case DesignAwardPlace.WINNER: {
      Badge = BadgeWinner;
      break;
    }
    default: {
      return null;
    }
  }

  return (
    <Badge

      className={classNames(
        styles.BadgeWrapper,
        className
      )}
    />
  );
}
